'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _colors = require('HubStyleTokens/colors');

var _UICheckmark = require('../icon/icons/UICheckmark');

var _UICheckmark2 = _interopRequireDefault(_UICheckmark);

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Checkable = require('../decorators/Checkable');

var _Checkable2 = _interopRequireDefault(_Checkable);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _Styles = require('../utils/Styles');

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _deprecated = require('../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _FocusProvider = require('../providers/FocusProvider');

var _FocusProvider2 = _interopRequireDefault(_FocusProvider);

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SIZE_VALUES = {
  default: 40,
  sm: 32,
  xs: 26
};

var Outer = _styledComponents2.default.label.withConfig({
  displayName: 'UIToggle__Outer'
})(['position:relative;display:inline-block;vertical-align:middle;user-select:none;color:', ';cursor:', ';'], function (_ref) {
  var onDark = _ref.onDark;
  return onDark && _colors.BATTLESHIP;
}, function (_ref2) {
  var disabledOrReadOnly = _ref2.disabledOrReadOnly;
  return disabledOrReadOnly ? 'not-allowed' : 'pointer';
});

var Switch = _styledComponents2.default.span.withConfig({
  displayName: 'UIToggle__Switch'
})(['position:relative;display:inline-block;vertical-align:middle;height:', 'px;width:', ';min-width:', 'px;background-color:', ';box-shadow:', ';', ';.hubspot-enable-focus-styles &{', ';}'], function (_ref3) {
  var size = _ref3.size;
  return SIZE_VALUES[size];
}, function (_ref4) {
  var size = _ref4.size;
  return size !== 'default' && SIZE_VALUES[size] * 2 + 'px';
}, function (_ref5) {
  var size = _ref5.size;
  return size === 'default' ? 80 : 0;
}, function (_ref6) {
  var checked = _ref6.checked,
      disabledOrReadOnly = _ref6.disabledOrReadOnly,
      onDark = _ref6.onDark,
      size = _ref6.size;

  if (disabledOrReadOnly) return _colors.GYPSUM;
  if (checked) return _colors.CALYPSO;
  if (onDark) return _colors.HEFFALUMP;
  return size === 'default' ? _colors.KOALA : _colors.GYPSUM;
}, function (_ref7) {
  var checked = _ref7.checked,
      onDark = _ref7.onDark;
  return !checked && 'inset 0 0 0 1px ' + (onDark ? _colors.SLINKY : _colors.BATTLESHIP);
}, (0, _Styles.setBorderRadius)(), function (_ref8) {
  var focused = _ref8.focused;
  return focused && _Styles.uiFocus;
});

var Handle = _styledComponents2.default.span.withConfig({
  displayName: 'UIToggle__Handle'
})(['position:absolute;top:0;left:', ';transform:', ';height:', 'px;width:', 'px;padding:', 'px;overflow:hidden;background-color:', ';box-shadow:', ';', ';', ';'], function (_ref9) {
  var checked = _ref9.checked;
  return checked ? '100%' : 0;
}, function (_ref10) {
  var checked = _ref10.checked;
  return checked && 'translateX(-100%)';
}, function (_ref11) {
  var size = _ref11.size;
  return SIZE_VALUES[size];
}, function (_ref12) {
  var size = _ref12.size;
  return SIZE_VALUES[size];
}, function (_ref13) {
  var size = _ref13.size;
  return size === 'xs' ? 5 : 7;
}, function (_ref14) {
  var disabledOrReadOnly = _ref14.disabledOrReadOnly;
  return disabledOrReadOnly ? _colors.GYPSUM : _colors.OLAF;
}, function (_ref15) {
  var checked = _ref15.checked,
      disabledOrReadOnly = _ref15.disabledOrReadOnly,
      onDark = _ref15.onDark;

  var boxShadowColor = void 0;
  if (disabledOrReadOnly) {
    boxShadowColor = _colors.BATTLESHIP;
  } else if (checked) {
    boxShadowColor = _colors.CALYPSO;
  } else {
    boxShadowColor = onDark ? _colors.SLINKY : _colors.BATTLESHIP;
  }
  return '0 0 0 1px ' + boxShadowColor + ', 0 5px 5px 0 rgba(0, 0, 0, 0.08)';
}, (0, _Styles.setBorderRadius)(), (0, _Styles.setUiTransition)());

var Text = _styledComponents2.default.span.withConfig({
  displayName: 'UIToggle__Text'
})(['position:relative;display:block;top:', ';', ';text-align:center;line-height:41px;padding-left:', 'px;padding-right:', 'px;visibility:', ';color:', ';', ';'], function (_ref16) {
  var checked = _ref16.checked,
      size = _ref16.size;
  return size === 'default' && !checked && '-40px';
}, _Styles.FONT_FAMILIES.demibold, function (_ref17) {
  var checked = _ref17.checked;
  return checked ? 16 : 56;
}, function (_ref18) {
  var checked = _ref18.checked;
  return checked ? 56 : 16;
}, function (_ref19) {
  var visible = _ref19.visible;
  return !visible && 'hidden';
}, function (_ref20) {
  var checked = _ref20.checked,
      disabledOrReadOnly = _ref20.disabledOrReadOnly;

  if (disabledOrReadOnly) return _colors.BUTTON_DISABLED_TEXT;
  if (checked) return _colors.OLAF;
  return null;
}, (0, _Styles.setFontSmoothing)());

var Checkmark = (0, _styledComponents2.default)(function (_ref21) {
  var className = _ref21.className;
  return _react2.default.createElement(_UICheckmark2.default, { className: className });
}).withConfig({
  displayName: 'UIToggle__Checkmark'
})(['fill:', ';stroke:', ';stroke-width:2;'], function (_ref22) {
  var disabledOrReadOnly = _ref22.disabledOrReadOnly;
  return disabledOrReadOnly ? _colors.BUTTON_DISABLED_TEXT : _colors.CALYPSO;
}, function (_ref23) {
  var disabledOrReadOnly = _ref23.disabledOrReadOnly;
  return disabledOrReadOnly ? _colors.GYPSUM : _colors.OLAF;
});

var UIToggle = function (_PureComponent) {
  _inherits(UIToggle, _PureComponent);

  function UIToggle(props) {
    _classCallCheck(this, UIToggle);

    var _this = _possibleConstructorReturn(this, (UIToggle.__proto__ || Object.getPrototypeOf(UIToggle)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(UIToggle, [{
    key: 'handleChange',
    value: function handleChange(evt) {
      var _props = this.props,
          disabled = _props.disabled,
          onChange = _props.onChange,
          onCheckedChange = _props.onCheckedChange,
          readOnly = _props.readOnly;


      if (disabled || readOnly) {
        evt.preventDefault();
        return;
      }

      onChange(evt);
      (0, _Functions.callIfPossible)(onCheckedChange, (0, _SyntheticEvent2.default)(evt.target.checked)); // For backward compat
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          checked = _props2.checked,
          className = _props2.className,
          disabled = _props2.disabled,
          __focused = _props2.focused,
          id = _props2.id,
          name = _props2.name,
          __onChange = _props2.onChange,
          __onCheckedChange = _props2.onCheckedChange,
          onClick = _props2.onClick,
          readOnly = _props2.readOnly,
          size = _props2.size,
          textChecked = _props2.textChecked,
          textUnchecked = _props2.textUnchecked,
          use = _props2.use,
          rest = _objectWithoutProperties(_props2, ['checked', 'className', 'disabled', 'focused', 'id', 'name', 'onChange', 'onCheckedChange', 'onClick', 'readOnly', 'size', 'textChecked', 'textUnchecked', 'use']);

      var disabledOrReadOnly = disabled || readOnly;

      var labelClassName = (0, _classNames2.default)('uiToggle', 'private-form__toggle-switch', className, {
        'private-form__toggle-switch--disabled': disabledOrReadOnly
      });

      var switchClassName = (0, _classNames2.default)('uiToggleSwitch', 'private-form__toggle-switch__inner', {
        uiToggleSwitchOn: checked
      });

      var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);
      var onDark = use === 'on-dark';

      return _react2.default.createElement(
        _FocusProvider2.default,
        this.props,
        function (focusProviderProps) {
          var focused = focusProviderProps.focused,
              focusProviderRestProps = _objectWithoutProperties(focusProviderProps, ['focused']);

          return _react2.default.createElement(
            Outer,
            _extends({}, rest, focusProviderRestProps, {
              className: labelClassName,
              disabledOrReadOnly: disabledOrReadOnly,
              onDark: onDark,
              size: shorthandSize
            }),
            _react2.default.createElement('input', {
              checked: checked,
              disabled: disabled,
              className: 'private-form__toggle-input sr-only',
              id: id,
              name: name,
              onChange: _this2.handleChange,
              onClick: onClick,
              readOnly: readOnly,
              type: 'checkbox'
            }),
            _react2.default.createElement(
              Switch,
              {
                checked: checked,
                className: switchClassName,
                disabledOrReadOnly: disabledOrReadOnly,
                focused: focused,
                role: 'presentation',
                size: shorthandSize,
                onDark: onDark
              },
              _react2.default.createElement(
                Text,
                {
                  checked: true,
                  disabledOrReadOnly: disabledOrReadOnly,
                  size: shorthandSize,
                  visible: checked,
                  className: shorthandSize !== 'default' && 'sr-only'
                },
                (0, _lazyEval2.default)(textChecked)
              ),
              _react2.default.createElement(
                Text,
                {
                  checked: false,
                  disabledOrReadOnly: disabledOrReadOnly,
                  size: shorthandSize,
                  visible: !checked,
                  className: (0, _classNames2.default)('private-form__toggle-switch__label--unchecked', shorthandSize !== 'default' && 'sr-only')
                },
                (0, _lazyEval2.default)(textUnchecked)
              ),
              _react2.default.createElement(
                Handle,
                {
                  checked: checked,
                  disabledOrReadOnly: disabledOrReadOnly,
                  onDark: onDark,
                  size: shorthandSize
                },
                checked && _react2.default.createElement(Checkmark, { disabledOrReadOnly: disabledOrReadOnly })
              )
            )
          );
        }
      );
    }
  }]);

  return UIToggle;
}(_react.PureComponent);

UIToggle.propTypes = {
  checked: _react.PropTypes.bool.isRequired,
  disabled: _react.PropTypes.bool,
  focused: (0, _decorators.hidden)(_react.PropTypes.bool),
  name: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  onCheckedChange: (0, _deprecated2.default)(_react.PropTypes.func, {
    message: 'UIToggle: The `onCheckedChange` prop has been deprecated. Please use `onChange` ' + 'instead. Note that the API is slightly different: `onCheckedChange` receives ' + '`{ target: { value } }`, while `onChange` receives `{ target: { checked } }`.',
    key: 'UIToggle: onCheckedChange'
  }),
  readOnly: _react.PropTypes.bool,
  size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['xs', 'sm']), _react.PropTypes.oneOf(['default'])]).isRequired,
  textChecked: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired,
  textUnchecked: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired,
  use: _react.PropTypes.oneOf(['default', 'on-dark'])
};

UIToggle.defaultProps = {
  checked: false,
  size: 'default',
  textChecked: function textChecked() {
    return _I18n2.default.text('salesUI.UIToggle.checkedLabel');
  },
  textUnchecked: function textUnchecked() {
    return _I18n2.default.text('salesUI.UIToggle.uncheckedLabel');
  },
  use: 'default'
};

UIToggle.displayName = 'UIToggle';

exports.default = (0, _Checkable2.default)(UIToggle);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/input/UIToggle.js
// module id = 572
// module chunks = 171